<template>
    <colla class="collapp-comment-box">
        <colla class="collapp-comment-list">
            <colla v-show="loading" class="collapp-spinner"></colla>
            <colla class="collapp-ul">
                <comment v-for="comment in comments" :comment="comment"></comment>
            </colla>
        </colla>

        <comment-form v-on:commented="updateComment" :thread="thread"></comment-form>

    </colla>
</template>

<script>

    import Comment from './Comment.vue'
    import CommentForm from './CommentForm.vue'
    import { Draggable } from 'draggable-vue-directive'

    export default {

        props: ['thread'],

        data() {
            return {
                question: 'What you think about Vue.js',
                comments: [],
                loading: false,
                hovered: false,
                //thread: this.thread,
                handleId: "handle-id",
                draggableValue: {
                    initialPosition: { x: 10, y: 10 },
                    handle: undefined
                },
                rootUrl: this.$http.options.root
            }
        },

        directives: {
            Draggable,
        },

        components: {
            Comment,
            CommentForm
        },

        created() {
            this.loading = true;
            this.getThreadComments();
        },

        methods: {
            getThreadComments() {
                // Fetch the comments
                //console.log('thread');
                //console.log(this.thread);

                this.$http.get(this.$http.options.api + '/comments?thread=' + this.thread).then((response) => {
                    // success callback

                    //console.log('response');
                    var collectionResponse = response.data['hydra:member'];
                    //console.log(collectionResponse);

                    this.comments = collectionResponse;
                    this.loading = false;
                }, (response) => {
                    // error callback
                    console.error(response);
                    this.loading = false;
                });
            },
            updateComment(comment) {
                this.comments.push(comment);
            }
        },

        mounted() {
            this.draggableValue.handle = this.$refs[this.handleId];
        },

    }
</script>

<style>

    .colla-element:hover {
        outline: 1px dashed rgba(222, 123, 23, 0.5) !important;
    }

    .collapp-brand h3 {
        color: #47b784;
        font-size: 2em;
    }

    .collapp-brand h3 span {
        color: #36495d
    }

    .collapp-btn-primary {
        box-shadow: 2px 2px 2px #d2d2d2;
        background-color: #6f8aa7;
        padding: .5em 2em;
        display: inline-block;
        color: #FFF;
        text-decoration: none;
        border-radius: 3px;
        transition: all ease 0.3s;
    }

    .collapp-btn-primary:hover {
        background-color: #47b784
    }

    .collapp-comment-list {
        width: 400px;
        padding: 1em 0;
        display: block;
        margin-top: 40px;
    }

    .collapp-comment-list .collapp-ul {
        margin: 0;
        padding: 1em;
        display: block;
    }

    .collapp-comment-list .collapp-li {
        list-style: none;
        text-align: left;
        overflow: hidden;
        margin-bottom: 2em;
        padding: .4em;

        display: list-item;
    }

    .collapp-comment-list .collapp-profile {
        width: 63px;
        float: left;
        display: inline;
    }

    .collapp-comment-list .collapp-profile img {
        border-radius: 50%;
        border: 2px solid #FFF;
        width: 48px;
        height: 48px;
        background-color: #DDD;
        box-shadow: 0 0 5px #DDD;
    }

    .collapp-comment-list .collapp-msg {
        width: 86%;
        float: left;
        background-color: #FFF;
        border-radius: 0 5px 5px 5px;
        box-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.05);
        position: relative;
    }

    .collapp-comment-list .collapp-msg-body {
        padding: .8em;
        color: #666;
        line-height: 1.5
    }

    .collapp-comment-list .collapp-msg-body .colla:last-child {
        margin-bottom: 0;
    }

    .collapp-comment-list .collapp-msg-body:after {
        content: ' ';
        position: absolute;
        left: -13px;
        top: 0;
        border: 14px solid;
        border-color: #fff transparent transparent transparent;
    }

    .collapp-comment-list .collapp-name {
        margin: 0;
        color: #000;
        font-weight: bold;
        font-size: .8em;
    }

    .collapp-comment-list .collapp-date {
        /* float: right; */
        font-size: .75em;
        color: #999;
    }

    @media (max-width: 1200px) {

        .collapp-comment-list .collapp-msg {
            width: 80%;
        }
    }

    @media (max-width: 600px) {

        .collapp-brand img {
            width: 80px;
        }

        .collapp-brand h3 {
            font-size: 1.6em;
        }

        .collapp-comment-list .collapp-msg {
            width: 70%;
        }
    }
</style>


// WEBPACK FOOTER //
// CommentList.vue?2a4204ac